export default function MySQL_ALTERTABLE() {
  return (
    <div>
      <h2>MySQL_ALTERTABLE</h2>    </div>
  );
}